// extracted by mini-css-extract-plugin
module.exports = {"empty":"components-Price-Price__empty--3QMxs","fill":"components-Price-Price__fill--1vVXw"};